import React, { Component, Fragment } from 'react';
import PropTypes from 'proptypes';
import { FieldGroup, FieldControl, FormBuilder, Validators } from 'react-reactive-form';
import DatePicker from 'react-datepicker';
import { Auth, API } from 'aws-amplify';
import { readableResponseMessage, phoneNumberValidator } from 'ux-helpers';
import moment from 'moment';
import { Countries, Nationalities } from './../../../helpers/CountriesAndNationalities';
import { UniversityUSA, UniversityUK, UniversityAustralia } from './../../../helpers/University';
import './Forms.scss';

const isUnder18 = birthdate => {
  if (birthdate !== '') {
    const age = moment(birthdate)
      .fromNow()
      .substring(0, 2)
      .trim();
    return age < 18;
  } else {
    return false;
  }
};

const universityUSAValidation = (universityUSAKey, countryKey, studentKey, birthdate) => group => {
  const countryInput = group.controls[countryKey];
  const universityUSAInput = group.controls[universityUSAKey];
  const studentInput = group.controls[studentKey];
  const birthdateInput = group.controls[birthdate];
  if (
    countryInput.value === 'United States' &&
    studentInput.value === 'true' &&
    isUnder18(birthdateInput) === false &&
    universityUSAInput.value === ''
  ) {
    universityUSAInput.setErrors({ uniUSARequired: true });
  } else {
    universityUSAInput.setErrors(null);
  }
};

const universityUKValidation = (universityUKKey, countryKey, studentKey) => group => {
  const countryInput = group.controls[countryKey];
  const universityUKInput = group.controls[universityUKKey];
  const studentInput = group.controls[studentKey];
  if (
    countryInput.value === 'United Kingdom' &&
    studentInput.value === 'true' &&
    universityUKInput.value === ''
  ) {
    universityUKInput.setErrors({ uniUKRequired: true });
  } else {
    universityUKInput.setErrors(null);
  }
};

const universityAustraliaValidation = (universityAustraliaKey, countryKey, studentKey) => group => {
  const countryInput = group.controls[countryKey];
  const universityAustraliaInput = group.controls[universityAustraliaKey];
  const studentInput = group.controls[studentKey];

  if (
    countryInput.value === 'Australia' &&
    studentInput.value === 'true' &&
    universityAustraliaInput.value === ''
  ) {
    universityAustraliaInput.setErrors({ uniAustraliaRequired: true });
  } else {
    universityAustraliaInput.setErrors(null);
  }
};

export default class Application extends Component {
  state = {
    birthday: '',
    studentBoolean: false,
    howdidyouHearAns: '',
    universityCountry: null,
    activeModal: null,
  };

  componentDidMount() {
    const birthdayInput = document.getElementById('application-birthday');
    if (birthdayInput !== null) {
      birthdayInput.readOnly = true;
    }

    Auth.currentSession().then(user => {
      this.setState({
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
        },
      });
    });

    const universityUSAFieldControl = this.applicationForm.get('universityUSA');
    const universityUKFieldControl = this.applicationForm.get('universityUK');
    const universityAustraliaFieldControl = this.applicationForm.get('universityAustralia');
    const howDidYouHearFieldControl = this.applicationForm.get('howDidYouHear');
    const socialMediaPlatformFieldControl = this.applicationForm.get('socialMediaPlatform');
    const studentFieldControl = this.applicationForm.get('student');
    const countryFieldControl = this.applicationForm.get('country');
    const emailOptOutNewsletterEmailListFieldControl = this.applicationForm.get(
      'emailOptOutNewsletterEmailList'
    );
    const emailOptOutUpdatesEmailListFieldControl = this.applicationForm.get(
      'emailOptOutUpdatesEmailList'
    );
    const emailOptOutPromotionsEmailListFieldControl = this.applicationForm.get(
      'emailOptOutPromotionsEmailList'
    );

    emailOptOutNewsletterEmailListFieldControl.onValueChanges.subscribe(value => {
      if (value === 'false') {
        emailOptOutUpdatesEmailListFieldControl.value = false;
        emailOptOutPromotionsEmailListFieldControl.value = false;
      } else {
        emailOptOutUpdatesEmailListFieldControl.value = true;
        emailOptOutPromotionsEmailListFieldControl.value = true;
      }
    });

    studentFieldControl.onValueChanges.subscribe(value => {
      if (value === 'true') {
        this.setState({ studentBoolean: true });
      } else {
        this.setState({ studentBoolean: false });
        universityUSAFieldControl.value = '';
        universityUKFieldControl.value = '';
        universityAustraliaFieldControl.value = '';
      }
    });

    howDidYouHearFieldControl.onValueChanges.subscribe(value => {
      if (value === 'Social Media') {
        this.setState({ howdidyouHearAns: 'SM' });
      } else if (value === 'Other') {
        this.setState({ howdidyouHearAns: 'Other' });
      } else {
        this.setState({ howdidyouHearAns: '' });
        socialMediaPlatformFieldControl.value = '';
      }
    });

    countryFieldControl.onValueChanges.subscribe(value => {
      if (value !== 'United States' && value !== 'United Kingdom' && value !== 'Australia') {
        this.setState({ universityCountry: null });
      }
      if (value === 'United States') {
        this.setState({ universityCountry: value });
        universityUKFieldControl.value = '';
        universityAustraliaFieldControl.value = '';
      }
      if (value === 'United Kingdom') {
        this.setState({ universityCountry: value });
        universityUSAFieldControl.value = '';
        universityAustraliaFieldControl.value = '';
      }
      if (value === 'Australia') {
        this.setState({ universityCountry: value });
        universityUSAFieldControl.value = '';
        universityUKFieldControl.value = '';
      }
    });
  }

  applicationForm = FormBuilder.group(
    {
      firstName: [this.props.userProps.firstName, [Validators.required, Validators.maxLength(50)]],
      lastName: [this.props.userProps.lastName, [Validators.required, Validators.maxLength(50)]],
      preferredName: [
        this.props.userProps.firstName,
        [Validators.required, Validators.maxLength(50)],
      ],
      phoneNumber: [
        this.props.userProps.phoneNumber,
        [Validators.required, Validators.maxLength(50), phoneNumberValidator],
      ],
      emailAddress: [this.props.userProps.emailAddress, [Validators.required, Validators.email]],
      alternateEmailAddress: ['', [Validators.email]],
      birthdate: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      zipCode: [''],
      shirtSize: [''],
      country: ['', Validators.required],
      nationality: ['', Validators.required],
      state: [''],
      preferredLocation: ['', [Validators.required]],
      howDidYouHear: ['', [Validators.required]],
      otherWayHeard: [''],
      recommendedBy: [''],
      applicationStatement: ['', [Validators.required]],
      socialMediaPlatform: [''],
      instagram: [''],
      facebook: [''],
      student: ['', Validators.required],
      fundraising: ['', Validators.required],
      smsOptOut: ['false', Validators.required],
      emailOptOutNewsletterEmailList: ['false', Validators.required],
      emailOptOutPromotionsEmailList: ['false', Validators.required],
      emailOptOutUpdatesEmailList: ['false', Validators.required],
      attendedMeeting: ['', Validators.required],
      universityUSA: [''],
      universityUK: [''],
      universityAustralia: [''],
      universityOther: [''],
      major: [''],
      graduationYear: [''],
      genderIdentity: [''],
      pronouns: [''],
      source: ['volunteer-profile'],
    },
    {
      validators: [
        universityUSAValidation('universityUSA', 'country', 'student', 'birthdate'),
        universityUKValidation('universityUK', 'country', 'student'),
        universityAustraliaValidation('universityAustralia', 'country', 'student'),
      ],
    },
    {
      updateOn: 'blur',
    }
  );

  scrollToAlertMessage = () => {
    const scrollElement = document.getElementById('alert-message');
    if (scrollElement && scrollElement.offsetTop) {
      window.scrollTo({
        top: scrollElement.offsetTop - 100,
        behavior: 'smooth',
      });
    }
  };

  handleSubmit = e => {
    e.preventDefault();

    if (this.applicationForm.status === 'VALID') {
      this.setState({ loadingBtn: true });

      this.applicationForm.handleSubmit();

      const { headers } = this.state;

      headers['Content-Type'] = 'application/json';
      const options = {
        headers,
        body: this.applicationForm.value,
      };

      const {
        birthdate,
        country,
        nationality,
        gender,
        shirtSize,
        emailAddress,
      } = this.applicationForm.value;

      const additionalInfo = {
        birthdate,
        citizenship: country,
        nationality,
        gender,
        shirtSize,
      };

      window.localStorage.setItem('additionalInformation', JSON.stringify(additionalInfo));

      Auth.currentAuthenticatedUser().then(authenticatedUser => {
        if (
          authenticatedUser &&
          authenticatedUser['attributes'] &&
          authenticatedUser['attributes']['email']
        ) {
          if (emailAddress !== authenticatedUser['attributes']['email']) {
            this.setState({
              message:
                'Whoops! Please double-check that your email address is the same as the one you logged in with.',
            });
            this.scrollToAlertMessage();
          } else {
            // All good. Submit the application.
            API.post('give-api', '/apply/', options)
              .then(() => {
                this.props.setAppState({
                  ...this.state.user,
                  ...this.applicationForm.value,
                });
                this.props.setParentState('userProps', {
                  ...this.state.user,
                  ...this.applicationForm.value,
                });
                this.props.handleRouting();
              })
              .catch(error => {
                this.setState({
                  loadingBtn: false,
                  message: readableResponseMessage(error),
                });
                this.scrollToAlertMessage();
                this.applicationForm.handleSubmit();
              });
          }
        } else {
          this.setState({
            message:
              "Sorry! We're having an issue with your account. Please log-out and log-in again.",
          });
          this.scrollToAlertMessage();
        }
      });
    } else {
      this.setState({ message: 'Please fill in the required fields below' });
      this.scrollToAlertMessage();
      this.applicationForm.handleSubmit();
    }
  };

  handleBirthdayChange = date => {
    const formattedDate = moment(date).format('MM/DD/YYYY');
    this.applicationForm.controls.birthdate.setValue(formattedDate);
    this.setState({
      birthday: date,
    });
  };

  render() {
    const country = Countries.map(function(count, i) {
      if (Countries[i] === '') {
        return <option key={count} disabled />;
      } else {
        return (
          <option key={count} defaultValue={Countries[i]}>
            {Countries[i]}
          </option>
        );
      }
    });

    const nationalities = Nationalities.map(function(count, i) {
      if (Nationalities[i] === '') {
        return <option key={count} disabled />;
      } else {
        return (
          <option key={count} defaultValue={Nationalities[i]}>
            {Nationalities[i]}
          </option>
        );
      }
    });

    const universitiesUSA = UniversityUSA.map((count, i) => (
      <option key={count} value={UniversityUSA[i]}>
        {UniversityUSA[i]}
      </option>
    ));

    const universitiesUK = UniversityUK.map((count, i) => (
      <option key={count} value={UniversityUK[i]}>
        {UniversityUK[i]}
      </option>
    ));

    const universitiesAustralia = UniversityAustralia.map((count, i) => (
      <option key={count} value={UniversityAustralia[i]}>
        {UniversityAustralia[i]}
      </option>
    ));

    const { firstName, lastName, emailAddress, phoneNumber } = this.props.userProps;

    return (
      <div>
        <FieldGroup
          control={this.applicationForm}
          render={({ value, submitted }) => (
            <div className="justify-content-center">
              <div className="form-container">
                <form
                  name="Application"
                  id="application-form"
                  onSubmit={e => this.handleSubmit(e, value)}
                >
                  <h3>Application Form</h3>
                  <p
                    id="alert-message"
                    className={`center ${
                      this.state.message === 'Your profile was successfully updated.'
                        ? 'success'
                        : 'error'
                    }`}
                  >
                    {this.state.message}
                  </p>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="firstName"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div
                            className={`inputContainer ${pristine && firstName ? 'hidden' : ''}`}
                          >
                            <input
                              className="form-control"
                              type="text"
                              autoComplete="given-name"
                              {...handler()}
                            />
                            <label
                              htmlFor="firstName"
                              className={`label ${pristine && !firstName ? '' : 'notEmpty'}`}
                            >
                              First Name (Legal)
                              <span className="error">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                                {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="lastName"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className={`inputContainer ${pristine && lastName ? 'hidden' : ''}`}>
                            <input
                              className="form-control"
                              autoComplete="family-name"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="lastName"
                              className={`label ${pristine && !lastName ? '' : 'notEmpty'}`}
                            >
                              Last Name
                              <span className="error">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                                {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="preferredName"
                        render={({ handler, pristine, touched, hasError }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              autoComplete="nickname"
                              type="text"
                              {...handler()}
                            />
                            <label
                              htmlFor="preferredName"
                              className={`label ${pristine && !firstName ? '' : 'notEmpty'}`}
                            >
                              First Name (Preferred)
                              <span className="error">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                                {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12 padding-right">
                      <FieldControl
                        name="alternateEmailAddress"
                        render={({ handler, hasError, pristine, touched }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="text"
                              autoComplete="alternateEmailAddress"
                              {...handler()}
                            />
                            <label
                              htmlFor="confirmEmailAddress"
                              className={`label ${pristine ? '' : 'notEmpty'}`}
                            >
                              Alternate Email{' '}
                              <small>
                                {pristine && emailAddress ? ' not(' + emailAddress + ')' : ' '}
                              </small>
                              <span className="not-required"> - not required</span>
                              <span className="error">
                                {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                                {touched && hasError('email') && ' - Not a valid email'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="emailAddress"
                        render={({ handler, hasError, pristine, touched }) => (
                          <div
                            className={`inputContainer ${pristine && emailAddress ? 'hidden' : ''}`}
                          >
                            <input
                              className={`form-control`}
                              type="text"
                              autoComplete="email"
                              {...handler()}
                            />
                            <label
                              htmlFor="emailAddress"
                              className={`label ${pristine && !emailAddress ? '' : 'notEmpty'}`}
                            >
                              Email Address
                              <span className="error">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                                {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                                {touched && hasError('email') && ' - Not a valid email'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="phoneNumber"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div
                            className={`inputContainer ${pristine && phoneNumber ? 'hidden' : ''}`}
                          >
                            <input
                              className="form-control"
                              type="text"
                              autoComplete="tel"
                              {...handler()}
                            />
                            <label
                              htmlFor="phoneNumber"
                              className={`label ${pristine && !phoneNumber ? '' : 'notEmpty'}`}
                            >
                              Mobile Phone Number
                              <span className="error">
                                {((touched || submitted) &&
                                  hasError('required') &&
                                  ' - Required') ||
                                  (touched && hasError('phoneNumber') && (
                                    <span className="bubble-error-message">
                                      Format: XXX-XXX-XXXX, International X-XXX-XXX-XXXX
                                    </span>
                                  ))}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="birthdate"
                        render={({ touched, hasError, pristine }) => (
                          <div className="inputContainer datepicker">
                            <DatePicker
                              className="form-control"
                              id="application-birthday"
                              selected={
                                this.state.birthday !== ''
                                  ? moment(this.state.birthday, 'DD-MM-YYYY')
                                  : null
                              }
                              placeholderText="--"
                              onChange={this.handleBirthdayChange}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              maxDate={moment()}
                              popperModifiers={{
                                flip: {
                                  enabled: false,
                                },
                                preventOverflow: {
                                  enabled: true,
                                  escapeWithReference: false,
                                },
                              }}
                            />
                            <label htmlFor="birthdate" className="label notEmpty">
                              Birthday
                              <span className="error">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="nationality"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select
                              name="nationality"
                              className="custom-arrow form-control"
                              placeholder=""
                              {...handler()}
                            >
                              <option disabled value="">
                                {' '}
                                {'--'}
                              </option>
                              {nationalities}
                            </select>
                            <label
                              htmlFor="nationality"
                              className={`label ${pristine ? '' : 'notEmpty'}`}
                            >
                              Nationality (as stated on the passport you will use for travel)
                              <span className="error select-span-error-label-fix">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="country"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select
                              name="country"
                              className="custom-arrow form-control"
                              placeholder="booleanStudentTrue"
                              {...handler()}
                            >
                              <option disabled value="">
                                {' '}
                                {'--'}
                              </option>
                              {country}
                            </select>
                            <label
                              htmlFor="country"
                              className={`label ${pristine ? '' : 'notEmpty'}`}
                            >
                              Country of Residence
                              <span className="error select-span-error-label-fix">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="preferredLocation"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select className="custom-arrow form-control" {...handler()}>
                              <option disabled value="">
                                {' '}
                                {'--'}
                              </option>
                              <option value="USA: Hawaii">USA: Hawaii</option>
                              <option value="USA: Pacific Northwest">USA: Pacific Northwest</option>
                              <option value="Tanzania">Tanzania</option>
                              <option value="Nicaragua">Nicaragua</option>
                              <option value="Costa Rica">Costa Rica</option>
                              <option value="Thailand">Thailand</option>
                              <option value="Laos">Laos</option>
                              <option value="SE Asia: Thailand &amp; Laos">
                                SE Asia: Thailand &amp; Laos
                              </option>
                              <option value="WILD: Outdoor Leadership &amp; WFA Course">
                                WILD: Outdoor Leadership &amp; WFA Course
                              </option>
                              <option value="Trips Age 40+">Trips Age 40+</option>
                              <option value="Specialized Trip">Specialized Trip</option>
                              <option value="Undecided">Undecided</option>
                            </select>
                            <label
                              htmlFor="preferredLocation"
                              className={`label ${pristine ? '' : 'notEmpty'}`}
                            >
                              Preferred Location
                              <span className="error select-span-error-label-fix">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  {this.state.universityCountry &&
                    this.state.universityCountry === 'United States' && (
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <FieldControl
                            name="state"
                            render={({ handler, touched, hasError, pristine }) => (
                              <div className="inputContainer">
                                <select className="custom-arrow form-control" {...handler()}>
                                  <option disabled value="">
                                    {' '}
                                    {'--'}
                                  </option>
                                  <option value="Alabama">Alabama</option>
                                  <option value="Alaska">Alaska</option>
                                  <option value="Alberta">Alberta</option>
                                  <option value="Arizona">Arizona</option>
                                  <option value="Arkansas">Arkansas</option>
                                  <option value="British Columbia">British Columbia</option>
                                  <option value="California">California</option>
                                  <option value="Colorado">Colorado</option>
                                  <option value="Connecticut">Connecticut</option>
                                  <option value="Delaware">Delaware</option>
                                  <option value="District of Columbia">District of Columbia</option>
                                  <option value="Florida">Florida</option>
                                  <option value="Georgia">Georgia</option>
                                  <option value="Hawaii">Hawaii</option>
                                  <option value="Idaho">Idaho</option>
                                  <option value="Illinois">Illinois</option>
                                  <option value="Indiana">Indiana</option>
                                  <option value="Iowa">Iowa</option>
                                  <option value="Kansas">Kansas</option>
                                  <option value="Kentucky">Kentucky</option>
                                  <option value="Louisiana">Louisiana</option>
                                  <option value="Maine">Maine</option>
                                  <option value="Manitoba">Manitoba</option>
                                  <option value="Maryland">Maryland</option>
                                  <option value="Massachusetts">Massachusetts</option>
                                  <option value="Michigan">Michigan</option>
                                  <option value="Minnesota">Minnesota</option>
                                  <option value="Mississippi">Mississippi</option>
                                  <option value="Missouri">Missouri</option>
                                  <option value="Montana">Montana</option>
                                  <option value="Nebraska">Nebraska</option>
                                  <option value="Nevada">Nevada</option>
                                  <option value="New Brunswick">New Brunswick</option>
                                  <option value="New Hampshire">New Hampshire</option>
                                  <option value="New Jersey">New Jersey</option>
                                  <option value="New Mexico">New Mexico</option>
                                  <option value="New York">New York</option>
                                  <option value="Newfoundland">Newfoundland</option>
                                  <option value="North Carolina">North Carolina</option>
                                  <option value="North Dakota">North Dakota</option>
                                  <option value="Northwest Territories">
                                    Northwest Territories
                                  </option>
                                  <option value="Nova Scotia">Nova Scotia</option>
                                  <option value="Nunavut">Nunavut</option>
                                  <option value="Ohio">Ohio</option>
                                  <option value="Oklahoma">Oklahoma</option>
                                  <option value="Ontario">Ontario</option>
                                  <option value="Oregon">Oregon</option>
                                  <option value="Pennsylvania">Pennsylvania</option>
                                  <option value="Prince Edward Island">Prince Edward Island</option>
                                  <option value="Quebec">Quebec</option>
                                  <option value="Rhode Island">Rhode Island</option>
                                  <option value="Saskatchewan">Saskatchewan</option>
                                  <option value="South Carolina">South Carolina</option>
                                  <option value="South Dakota">South Dakota</option>
                                  <option value="Tennessee">Tennessee</option>
                                  <option value="Texas">Texas</option>
                                  <option value="Utah">Utah</option>
                                  <option value="Vermont">Vermont</option>
                                  <option value="Virginia">Virginia</option>
                                  <option value="Washington">Washington</option>
                                  <option value="West Virginia">West Virginia</option>
                                  <option value="Wisconsin">Wisconsin</option>
                                  <option value="Wyoming">Wyoming</option>
                                  <option value="Yukon">Yukon</option>
                                </select>
                                <label
                                  htmlFor="state"
                                  className={`label ${pristine ? '' : 'notEmpty'}`}
                                >
                                  State
                                  <span className="error select-span-error-label-fix">
                                    {(touched || submitted) &&
                                      hasError('required') &&
                                      ' - Required'}
                                  </span>
                                </label>
                              </div>
                            )}
                          />
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <FieldControl
                            name="zipCode"
                            render={({ handler, touched, hasError, pristine }) => (
                              <div className="inputContainer">
                                <input
                                  className="form-control"
                                  type="text"
                                  autoComplete="postal-code"
                                  {...handler()}
                                />
                                <label
                                  htmlFor="zipCode"
                                  className={`label ${pristine ? '' : 'notEmpty'}`}
                                >
                                  Zip Code
                                  <span className="error">
                                    {(touched || submitted) &&
                                      hasError('required') &&
                                      ' - Required'}
                                    {hasError('maxLength') &&
                                      ' - Exceeds Maximum Number of Characters'}
                                  </span>
                                </label>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    )}
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="gender"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select
                              name="gender"
                              className="custom-arrow form-control"
                              placeholder=""
                              {...handler()}
                            >
                              <option disabled value="">
                                {' '}
                                {' - Select - '}
                              </option>
                              <option value="Female">Female</option>
                              <option value="Male">Male</option>
                            </select>
                            <label
                              htmlFor="gender"
                              className={`label ${pristine ? '' : 'notEmpty'}`}
                            >
                              Gender (on birth certificate or passport)
                              <span className="error select-span-error-label-fix">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="genderIdentity"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select
                              name="genderIdentity"
                              className="custom-arrow form-control"
                              placeholder=""
                              {...handler()}
                            >
                              <option disabled value="">
                                {' '}
                                {' - Select - '}
                              </option>
                              <option value="Female">Female</option>
                              <option value="Male">Male</option>
                              <option value="Transgender Female">Transgender Female</option>
                              <option value="Transgender Male">Transgender Male</option>
                              <option value="Agender">Agender</option>
                              <option value="Not Listed">Not Listed</option>
                            </select>
                            <label htmlFor="genderIdentity" className="label">
                              Gender Identity (with which you identify)
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="howDidYouHear"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <select className="custom-arrow form-control" {...handler()}>
                              <option disabled value="">
                                {' '}
                                {'--'}
                              </option>
                              <option value="I received a flyer">I received a flyer</option>
                              <option value="I saw a poster">I saw a poster</option>
                              <option value="I received an email">I received an email</option>
                              <option value="In class">In class</option>
                              <option value="Through a past volunteer">
                                Through a past volunteer
                              </option>
                              <option value="Through a friend">Through a friend</option>
                              <option value="Through a Professor or Faculty">
                                Through a Professor or Faculty
                              </option>
                              <option value="Online Search">Online Search</option>
                              <option value="Social Media">Social Media</option>
                              <option value="From my study abroad office">
                                From my study abroad office
                              </option>
                              <option value="Greek Life">Greek Life</option>
                              <option value="Involvement Fair">Involvement Fair</option>
                              <option value="Other">Other</option>
                            </select>
                            <label
                              htmlFor="howDidYouHear"
                              className={`label ${pristine ? '' : 'notEmpty'}`}
                            >
                              How did you hear about Give?
                              <span className="error select-span-error-label-fix">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    {this.state.howdidyouHearAns === 'SM' ? (
                      <div className="col-md-12 col-sm-12">
                        <FieldControl
                          name="socialMediaPlatform"
                          render={({ handler, pristine }) => (
                            <div className="inputContainer">
                              <select className="custom-arrow form-control" {...handler()}>
                                <option disabled value="">
                                  {' '}
                                  What Social Media Platform?{' '}
                                </option>
                                <option value="Facebook">Facebook</option>
                                <option value="Instagram (saw a friend's epic pics)">
                                  Instagram (saw a friend's epic pics)
                                </option>
                                <option value="Instagram (discovered @givevolunteers)">
                                  Instagram (discovered @givevolunteers)
                                </option>
                                <option value="Tumblr">Tumblr</option>
                                <option value="Twitter">Twitter</option>
                                <option value="Pinterest">Pinterest</option>
                                <option value="YouTube">YouTube</option>
                                <option value="TikTok">TikTok</option>
                                <option value="Vimeo">Vimeo</option>
                                <option value="LinkedIn">LinkedIn</option>
                                <option value="Other">Other</option>
                              </select>
                              <label
                                htmlFor="socialMediaPlatform"
                                className={`label ${pristine ? '' : 'notEmpty'}`}
                              >
                                Social Media Platform{' '}
                                <span className="not-required select-span-error-label-fix">
                                  {' '}
                                  - not required
                                </span>
                              </label>
                            </div>
                          )}
                        />
                      </div>
                    ) : null}
                    {this.state.howdidyouHearAns === 'Other' ? (
                      <div className="col-md-12 col-sm-12">
                        <FieldControl
                          name="otherWayHeard"
                          render={({ handler, pristine }) => (
                            <div className="inputContainer">
                              <input className="form-control" type="text" {...handler()} />
                              <label
                                htmlFor="otherWayHeard"
                                className={`label label-fix ${pristine ? '' : 'notEmpty'}`}
                              >
                                Other Way Heard{' '}
                                <span className="not-required"> - not required</span>
                              </label>
                            </div>
                          )}
                        />
                      </div>
                    ) : null}
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="recommendedBy"
                        render={({ handler, pristine }) => (
                          <div className="inputContainer">
                            <input className="form-control" type="text" {...handler()} />
                            <label
                              htmlFor="recommendedBy"
                              className={`label label-fix ${pristine ? '' : 'notEmpty'}`}
                            >
                              Recommended By <span className="not-required"> - not required</span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <FieldControl
                        name="instagramHandle"
                        render={({ handler, pristine }) => (
                          <div className="inputContainer">
                            <input className="form-control" type="text" {...handler()} />
                            <label
                              htmlFor="instagramHandle"
                              className={`label label-fix ${pristine ? '' : 'notEmpty'}`}
                            >
                              Instagram Handle <span className="not-required"> - not required</span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="applicationStatement"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <textarea className="form-control" type="text" {...handler()} />
                            <label
                              htmlFor="applicationStatement"
                              className={`label ${pristine ? '' : 'notEmpty'}`}
                            >
                              Why would you like to travel with Give?
                              <span className="error">
                                {(touched || submitted) && hasError('required') && ' - Required'}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="fundraising"
                        render={({ handler, touched, hasError }) => (
                          <div className="form-control">
                            Do you plan on fundraising?
                            <span className="error">
                              {(touched || submitted) && hasError('required') && ' - Required'}
                            </span>
                            <input
                              className="radio-button"
                              name="fundraising"
                              id="fundraising-yes"
                              type="radio"
                              {...handler('radio', 'true')}
                            />
                            <label htmlFor="fundraising-yes">Yes</label>
                            <input
                              className="radio-button"
                              name="fundraising"
                              id="fundraising-no"
                              type="radio"
                              {...handler('radio', 'false')}
                            />
                            <label htmlFor="fundraising-no">No</label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="attendedMeeting"
                        render={({ handler, touched, hasError }) => (
                          <div className="form-control">
                            Did you attend a GIVE meeting/presentation?
                            <span className="error">
                              {(touched || submitted) && hasError('required') && ' - Required'}
                            </span>
                            <input
                              className="radio-button"
                              name="attendedMeeting"
                              id="am-yes"
                              type="radio"
                              {...handler('radio', 'true')}
                            />
                            <label htmlFor="am-yes">Yes</label>
                            <input
                              className="radio-button"
                              name="attendedMeeting"
                              id="am-no"
                              type="radio"
                              {...handler('radio', 'false')}
                            />
                            <label htmlFor="am-no">No</label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="smsOptOut"
                        render={({ handler, touched, hasError }) => (
                          <div className="form-control">
                            Is it okay to send text messages for important notifications &amp;
                            updates?
                            <span className="error">
                              {(touched || submitted) && hasError('required') && ' - Required'}
                            </span>
                            <input
                              className="radio-button"
                              name="smsOptOut"
                              id="sms-yes"
                              type="radio"
                              {...handler('radio', 'false')}
                            />
                            <label htmlFor="sms-yes">Yes</label>
                            <input
                              className="radio-button"
                              name="smsOptOut"
                              id="sms-no"
                              type="radio"
                              {...handler('radio', 'true')}
                            />
                            <label htmlFor="sms-no">No</label>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <FieldControl
                        name="student"
                        render={({ handler, touched, hasError }) => (
                          <div className="form-control">
                            Are you a currently a student?
                            <span className="error">
                              {(touched || submitted) && hasError('required') && ' - Required'}
                            </span>
                            <input
                              className="radio-button"
                              name="student"
                              id="student-yes"
                              type="radio"
                              {...handler('radio', 'true')}
                            />
                            <label htmlFor="student-yes">Yes</label>
                            <input
                              className="radio-button"
                              name="student"
                              id="student-no"
                              type="radio"
                              {...handler('radio', 'false')}
                            />
                            <label htmlFor="student-no">No</label>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  {this.state.studentBoolean ? (
                    <div>
                      <h3 className="col-md-12 form-sub-title">School Information</h3>
                      {isUnder18(this.applicationForm.controls['birthdate'].value) ? (
                        <div className="row">
                          <div className="col-md-6 col-sm-12 padding-right">
                            <FieldControl
                              name="highschool"
                              render={({ handler, touched, hasError, pristine }) => (
                                <div className="inputContainer">
                                  <input className="form-control" type="text" {...handler()} />
                                  <label
                                    htmlFor="highschool"
                                    className={`label ${pristine ? '' : 'notEmpty'}`}
                                  >
                                    Highschool Name
                                    <span className="error">
                                      {(touched || submitted) &&
                                        hasError('required') &&
                                        ' - Required'}
                                    </span>
                                  </label>
                                </div>
                              )}
                            />
                          </div>
                          <div className="col-md-6 col-sm-12 padding-right">
                            <FieldControl
                              name="graduationYear"
                              render={({ handler, pristine }) => (
                                <div className="inputContainer">
                                  <select className="custom-arrow form-control" {...handler()}>
                                    <option disabled value="">
                                      Graduation Year
                                    </option>
                                    <option value="2020">2020</option>
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                    <option value="2024">2024</option>
                                    <option value="2025">2025</option>
                                    <option value="2026">2026</option>
                                    <option value="2027">2027</option>
                                    <option value="2028">2028</option>
                                    <option value="2029">2029</option>
                                    <option value="2030">2030</option>
                                    <option value="2031">2031</option>
                                    <option value="2032">2032</option>
                                    <option value="2033">2033</option>
                                    <option value="2034">2034</option>
                                    <option value="2035">2035</option>
                                    <option value="2036">2036</option>
                                    <option value="2037">2037</option>
                                    <option value="2038">2038</option>
                                    <option value="2039">2039</option>
                                    <option value="2040">2040</option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label
                                    htmlFor="graduationYear"
                                    className={`label ${pristine ? '' : 'notEmpty'}`}
                                  >
                                    Graduation Year{' '}
                                    <span className="not-required select-span-error-label-fix">
                                      {' '}
                                      - not required
                                    </span>
                                  </label>
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      ) : (
                        <Fragment>
                          <div className="row">
                            {this.state.universityCountry === 'United States' ? (
                              <div className="col-md-12 col-sm-12 padding-right">
                                <FieldControl
                                  name="universityUSA"
                                  render={({ handler, pristine, touched, hasError }) => (
                                    <div className="inputContainer">
                                      <select className="custom-arrow form-control" {...handler()}>
                                        <option disabled value="">
                                          {' '}
                                          What university are you attending{' '}
                                        </option>
                                        {universitiesUSA}
                                      </select>
                                      <label
                                        htmlFor="universityUSA"
                                        className={`label ${pristine ? '' : 'notEmpty'}`}
                                      >
                                        USA University
                                        <span className="error select-span-error-label-fix">
                                          {(touched || submitted) &&
                                            hasError('uniUSARequired') &&
                                            ' - Required'}
                                        </span>
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                            ) : null}
                            {this.state.universityCountry === 'United Kingdom' ? (
                              <div className="col-md-12 col-sm-12 padding-right">
                                <FieldControl
                                  name="universityUK"
                                  render={({ handler, pristine, touched, hasError }) => (
                                    <div className="inputContainer">
                                      <select className="custom-arrow form-control" {...handler()}>
                                        <option disabled value="">
                                          {' '}
                                          What university are you attending/have attended?{' '}
                                        </option>
                                        {universitiesUK}
                                      </select>
                                      <label
                                        htmlFor="universityUK"
                                        className={`label ${pristine ? '' : 'notEmpty'}`}
                                      >
                                        UK University
                                        <span className="error select-span-error-label-fix">
                                          {(touched || submitted) &&
                                            hasError('uniUKRequired') &&
                                            ' - Required'}
                                        </span>
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                            ) : null}
                            {this.state.universityCountry === 'Australia' ? (
                              <div className="col-md-12 col-sm-12">
                                <FieldControl
                                  name="universityAustralia"
                                  render={({ handler, pristine, touched, hasError }) => (
                                    <div className="inputContainer">
                                      <select className="custom-arrow form-control" {...handler()}>
                                        <option disabled value="">
                                          {' '}
                                          What university are you attending/have attended?{' '}
                                        </option>
                                        {universitiesAustralia}
                                      </select>
                                      <label
                                        htmlFor="universityAustralia"
                                        className={`label ${pristine ? '' : 'notEmpty'}`}
                                      >
                                        Australia University
                                        <span className="error select-span-error-label-fix">
                                          {(touched || submitted) &&
                                            hasError('uniAustraliaRequired') &&
                                            ' - Required'}
                                        </span>
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                            ) : null}
                          </div>
                          {this.applicationForm.controls.universityUSA.value === 'Other' ||
                          this.applicationForm.controls.universityUK.value === 'Other' ||
                          this.applicationForm.controls.universityAustralia.value === 'Other' ? (
                            <div className="row">
                              <div className="col-md-12 col-sm-12">
                                <FieldControl
                                  name="universityOther"
                                  render={({ handler, touched, hasError, pristine }) => (
                                    <div className="inputContainer">
                                      <input className="form-control" type="text" {...handler()} />
                                      <label
                                        htmlFor="universityOther"
                                        className={`label ${pristine ? '' : 'notEmpty'}`}
                                      >
                                        University Name
                                        <span className="error">
                                          {(touched || submitted) &&
                                            hasError('required') &&
                                            ' - Required'}
                                        </span>
                                      </label>
                                    </div>
                                  )}
                                />
                              </div>
                            </div>
                          ) : null}
                          <div className="row">
                            <div className="col-md-6 col-sm-12">
                              <FieldControl
                                name="major"
                                render={({ handler, pristine }) => (
                                  <div className="inputContainer">
                                    <input className="form-control" type="text" {...handler()} />
                                    <label
                                      htmlFor="major"
                                      className={`label label-fix ${pristine ? '' : 'notEmpty'}`}
                                    >
                                      Major <span className="not-required"> - not required</span>
                                    </label>
                                  </div>
                                )}
                              />
                            </div>
                            <div className="col-md-6 col-sm-12 padding-right">
                              <FieldControl
                                name="graduationYear"
                                render={({ handler, pristine }) => (
                                  <div className="inputContainer">
                                    <select className="custom-arrow form-control" {...handler()}>
                                      <option disabled value="">
                                        Graduation Year
                                      </option>
                                      <option value="2020">2020</option>
                                      <option value="2021">2021</option>
                                      <option value="2022">2022</option>
                                      <option value="2023">2023</option>
                                      <option value="2024">2024</option>
                                      <option value="2025">2025</option>
                                      <option value="2026">2026</option>
                                      <option value="2027">2027</option>
                                      <option value="2028">2028</option>
                                      <option value="2029">2029</option>
                                      <option value="2030">2030</option>
                                      <option value="2031">2031</option>
                                      <option value="2032">2032</option>
                                      <option value="2033">2033</option>
                                      <option value="2034">2034</option>
                                      <option value="2035">2035</option>
                                      <option value="2036">2036</option>
                                      <option value="2037">2037</option>
                                      <option value="2038">2038</option>
                                      <option value="2039">2039</option>
                                      <option value="2040">2040</option>
                                      <option value="Other">Other</option>
                                    </select>
                                    <label
                                      htmlFor="graduationYear"
                                      className={`label ${pristine ? '' : 'notEmpty'}`}
                                    >
                                      Select Year{' '}
                                      <span className="not-required select-span-error-label-fix">
                                        {' '}
                                        - not required
                                      </span>
                                    </label>
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  ) : null}
                  <div className="row top-padding">
                    <div className="col-md-12 col-sm-12 padding-right">
                      <button
                        className={`margin-center ${this.state.loadingBtn ? 'btn-text-hide' : ''}`}
                        type="submit"
                        disabled={this.state.loadingBtn}
                      >
                        Submit
                        <span className={`${this.state.loadingBtn ? 'loader' : ''}`} />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        />
      </div>
    );
  }
}

Application.propTypes = {
  handleRouting: PropTypes.func.isRequired,
  setParentState: PropTypes.func.isRequired,
  setAppState: PropTypes.func.isRequired,
  userProps: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    emailAddress: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
};
